import { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';
import { groupMasterApi } from '../api/groupMasterApi';
import { appToast } from '../../../../components/AppToast';

const EMPTY_FORM = {
  name: '',
  weeklyOff: 'Select',
  secondWeeklyOff: 'Select',
};

export function useGroupMasterEntry() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: routeId } = useParams();
  const [searchParams] = useSearchParams();
  const editId = routeId || searchParams.get('id');
  const isEdit = Boolean(editId);

  const listPath = location.pathname.startsWith('/masters')
    ? '/masters/employee-group'
    : '/payroll/employee-group';

  const [form, setForm] = useState(EMPTY_FORM);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isEdit) {
      setIsLoading(true);
      groupMasterApi.getById(Number(editId)).then((data) => {
        if (data) {
          setForm({
            name: data.name || '',
            weeklyOff: data.weeklyOff || 'Select',
            secondWeeklyOff: data.secondWeeklyOff || 'Select',
          });
        }
        setIsLoading(false);
      });
    }
  }, [editId, isEdit]);

  const patchForm = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const validate = () => {
    if (!form.name.trim()) {
      appToast.error('Group Name is required.');
      return false;
    }
    if (!form.weeklyOff || form.weeklyOff === 'Select') {
      appToast.error('Weekly Off is required.');
      return false;
    }
    return true;
  };

  const handleSave = async ({ exitAfter = true } = {}) => {
    if (!validate()) return;
    setIsSaving(true);
    try {
      if (isEdit) {
        await groupMasterApi.update(Number(editId), form);
        appToast.success('Employee Group updated successfully.');
      } else {
        await groupMasterApi.create(form);
        appToast.success('Employee Group created successfully.');
      }

      if (exitAfter) {
        navigate(listPath);
      } else {
        setForm(EMPTY_FORM);
      }
    } catch (err) {
      appToast.error('Failed to save Employee Group.');
    } finally {
      setIsSaving(false);
    }
  };

  return {
    state: { form, isLoading, isSaving, isEdit, listPath },
    actions: { patchForm, handleSave },
  };
}
